module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: ['section-carousel swiper-container ', _vm.carousel_sub_class]
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.carousel_slides), function(slide, index) {
    return _c('div', {
      key: index,
      class: [
        'section-carousel__slide swiper-slide',
        slide.slide_theme === 'light' ?
        'section-carousel__slide--light' :
        'section-carousel__slide--dark' ],
      attrs: {
        "data-swiper-autoplay": slide.slide_duration * 1000
      }
    }, [_c('div', {
      staticClass: "container"
    }, [_c('h1', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(slide.title)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "description",
      domProps: {
        "innerHTML": _vm._s(slide.description)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "description--small",
      domProps: {
        "innerHTML": _vm._s(slide.small_text)
      }
    }), _vm._v(" "), (slide.read_more) ? _c('a', {
      staticClass: "read-more btn",
      attrs: {
        "href": slide.read_more.url
      },
      domProps: {
        "textContent": _vm._s(slide.read_more.title)
      }
    }) : _vm._e()]), _vm._v(" "), (slide.slide_type === 'image') ? _c('div', {
      class: [
        'bg',
        slide.slide_theme === 'light' ? 'bg--light' : 'bg--dark' ],
      style: ({
        'background-image': 'url( ' + slide.background_image.url + ' )',
        'background-position': slide.horizontal_position + '% ' + slide.vertical_position + '%',
      })
    }) : _vm._e(), _vm._v(" "), (slide.slide_type === 'video') ? _c('video', {
      class: [
        'bg',
        slide.slide_theme === 'white' ? 'bg--light' : 'bg--dark' ],
      attrs: {
        "poster": slide.background_video_poster.url,
        "autoplay": "",
        "muted": "",
        "playsinline": "",
        "loop": ""
      },
      domProps: {
        "muted": true
      }
    }, [(slide.background_video_mp4.url) ? _c('source', {
      attrs: {
        "src": slide.background_video_mp4.url,
        "type": "video/mp4"
      }
    }) : _vm._e(), _vm._v(" "), (slide.background_video_ogg.url) ? _c('source', {
      attrs: {
        "src": slide.background_video_ogg.url,
        "type": "video/ogg"
      }
    }) : _vm._e(), _vm._v(" "), (slide.background_video_webm.url) ? _c('source', {
      attrs: {
        "src": slide.background_video_webm.url,
        "type": "video/webm"
      }
    }) : _vm._e()]) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.showSliderArrows) ? _c('div', {
    staticClass: "section-carousel__prev"
  }) : _vm._e(), _vm._v(" "), (_vm.showSliderArrows) ? _c('div', {
    staticClass: "section-carousel__next"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a44dec8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlockCarousel.vue
// module id = 359
// module chunks = 0